import _ from 'underscore';
import { getAdEntityPreviewCell } from './ad-preview-helper';

// format returned value into two decimal strings
function formatValueToFixed(i18n, value) {
  return i18n.formatDecimalToFixed(parseFloat(value));
}

function formatEntityValue(item, entityKeys, defaultEntityValue) {
  const entity = _.find(item.EntityKey, it => entityKeys.indexOf(it.Key) >= 0);

  return { value: entity && entity.Value ? entity.Value : defaultEntityValue, isHtml: false };
}

/**
 * Format the status results of bulk edit response to formats used by PreviewResultView
 * @param {Object[]} rows - raw result rows from bulk edit result
 * @param {String[]} entityKeys - the entity keys, using it to find entityname from response
 * @param {Object} i18n - localization setting
 * @param {String} defaultEntityValue - default entity value, used when missing from result,
 *   optional
 * @param {String} entity - entity type, ex) ad, adGroup
 *
 * @returns {Object} formated result, [{data: {value, isHtml}}]
 */
export function formatStatus(rows, entityKeys, i18n, defaultEntityValue, entity) {
  const result = [];
  if (rows && rows.length) {
    _.each(rows, (item) => {
      const data = [];

      if (entity === 'Ad') {
        const entityValues = {};
        _.each(item.EntityKey, (entityItem) => {
          entityValues[entityItem.Key] = entityItem.Value;
        });

        data.push(getAdEntityPreviewCell(entityValues, i18n));
      } else {
        data.push(formatEntityValue(item, entityKeys, defaultEntityValue));
      }

      if (item.Changes && item.Changes.length) {
        data.push({ value: i18n.getString(`EntityStatus_${item.Changes[0].OriginalValue}`), isHtml: false });
        data.push({ value: i18n.getString(`EntityStatus_${item.Changes[0].NewValue}`), isHtml: false });
      } else {
        data.push({ value: '', isHtml: false });
        data.push({ value: '', isHtml: false });
      }
      result.push({ data });
    });
  }

  return result;
}

/**
 * Format the bid/budget results of bulk edit response to formats used by PreviewResultView
 * @param {Object[]} rows - raw result rows from bulk edit result
 * @param {String[]} entityKeys - the entity keys, using it to find entityname from response
 * @param {Object} i18n - localization setting
 *
 * @returns {Object} formated result, [{data: {value, isHtml}}]
 */
export function formatBidBudget(rows, entityKeys, i18n) {
  const result = [];
  if (rows && rows.length) {
    _.each(rows, (value) => {
      const data = [formatEntityValue(value, entityKeys)];

      if (value.Changes && value.Changes.length) {
        // for changeBudget we can only have one element in value.Changes array
        data.push({
          value: formatValueToFixed(i18n, value.Changes[0].OriginalValue),
          isHtml: false,
        });
        data.push({
          value: formatValueToFixed(i18n, value.Changes[0].NewValue),
          isHtml: false,
        });
      } else {
        data.push({ value: '', isHtml: false });
        data.push({ value: '', isHtml: false });
      }
      result.push({ data });
    });
  }
  return result;
}


/**
 * Format the email results of bulk edit response to formats used by PreviewResultView
 * @param {Object[]} rows - raw result rows from bulk edit result
 * @param {String[]} entityKeys - the entity keys, using it to find entityname from response
 * @param {String} defaultEntityValue - default entity value, used when missing from result,
 *   optional
 *
 * @returns {Object} formated result, [{data: {value, isHtml}}]
 */
export function formatEmail(rows, entityKeys, defaultEntityValue) {
  const result = [];
  if (rows && rows.length) {
    _.each(rows, (item) => {
      result.push({ data: [formatEntityValue(item, entityKeys, defaultEntityValue)] });
    });
  }
  return result;
}
